import { supabase } from '@/lib/supabase/supabaseClient';

export const restoreQuestion = async (question_id: string) => {
    return await supabase
        .from('question')
        .update({ archived: false })
        .eq('id', question_id)
        .select()
        .throwOnError()
        .then(res => res.data);
}